import { GET_ORDERS, GET_DETAIL, SET_LOADING, GET_REFERENCE_DATA } from '../types/order';

export function getOrders(params) {
  return {
    type: GET_ORDERS,
    params,
  };
}

export function getOrderDetail(params) {
  return {
    type: GET_DETAIL,
    params,
  };
}

export function setLoading(isLoading = false) {
  return {
    type: SET_LOADING,
    isLoading,
  };
}

export function getReferenceData(params) {
  return {
    type: GET_REFERENCE_DATA,
    params,
  };
}
